import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3b4f76ed")

_pushScopeId("data-v-3b4f76ed")
const _hoisted_1 = {
  class: "widePagePadding hasHeader hasFooter",
  ref: "scroll_section"
}
const _hoisted_2 = { class: "header d-flex aling-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "w-100"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "searchContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/globalSearch')))
      }, [
        _hoisted_3,
        _createVNode(_component_localized_text, {
          class: "fs_12 greyBlue ms-2",
          localizedKey: "app_globalSearchText",
          text: "Communities, eventi, fiere, brand..."
        })
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_mini_spinner, { class: "my-4" })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (item, i) => {
      return (_openBlock(), _createBlock(_component_post, {
        class: "mb-3",
        key: item.identifier,
        ref: item.identifier,
        post: item,
        "community-identifier": item.parentIdentifier,
        onRemoved: ($event: any) => (_ctx.onRemoved($event, i)),
        "can-content": item.creator.identifier == _ctx.$store.state.user.identifier,
        showCommunityTitle: true
      }, null, 8, ["post", "community-identifier", "onRemoved", "can-content"]))
    }), 128))
  ], 512))
})